import { ComponentRef } from '@angular/core';
import { WorkspacePanels } from './panels-menu/workspace-panels';

export interface PanelModel {
  panelId: string;
  workspaceId: string;
  layoutTabId: string;
  /** The panel type's full (default) name. Never overwritten by a rename — see `customHeader`. */
  header: string;

  /**
   * CR-20260928-002. The tab's OWN name, set by the double-click rename and saved with the
   * layout. It always wins over a panel alias; empty/undefined = none (the tab shows the alias
   * if set, else `header`). Resolve through `PanelAliasesService.displayName(panel)`.
   */
  customHeader?: string;
  isActive?: boolean;
  instance?: ComponentRef<any>;
  typeCode: WorkspacePanels;
  
  /**
   * Flag to indicate that this panel descriptor is undergoing restoring process
   */
  isRestoring?: boolean;

  isSymbolLinkCompatible: boolean;
  isLinkedToSymbol?: boolean;

  /**
   * A pinned panel stays first and is left out of the re-arrange dialog.
   * Computed when the panel is added, never persisted.
   */
  isPinned?: boolean;
  /** Runtime close permission; absent retains the default (unpinned panels can close). */
  isClosable?: boolean;
}

export function isPanelClosable(panel: PanelModel): boolean {
  return !!panel && (panel.isClosable !== undefined ? panel.isClosable : !panel.isPinned);
}
